const DEFAULT_ASSET_LOGO_SIZE = 16;

export {DEFAULT_ASSET_LOGO_SIZE};
